export default "__VITE_ASSET__0d721d5e__"